<template>
  <div class="m_aptitude_safe">
    <MobilePageBanner
      :background-image="
        require('@/assets/images/mobile/aptitude_safe/banner@2x.png')
      "
      :slogans="['互联网认证服务，', '帮助平台搭建安全业务体系']"
      button-href="https://www.yunaq.com/activity/activityform?name=业务安全"
    ></MobilePageBanner>
    <div class="m_des">
      为互联网平台提供认证体系搭建咨询和实施服务，从准入规则、认证分级、验证流程到结果应用，解决互联网平台上的违规虚假、品牌仿冒、用户欺诈的问题，净化平台服务和交易环境。
    </div>
    <div class="m_panel">
      <div class="m_title">行业痛点</div>
      <div class="masp_icon">
        <img src="@/assets/images/zizhi/tongdian1@2x.png" alt="" />
      </div>
      <div class="masp_title">社会责任要求</div>
      <div class="m_des_item Mb24">
        网络安全法要求经营者互联网开展经营和服务活动，应当遵守商业道德，诚实信用，并对平台的服务负有监督义务和社会责任。
      </div>
      <div class="masp_icon">
        <img src="@/assets/images/zizhi/tongdian2@2x.png" alt="" />
      </div>
      <div class="masp_title">缺乏认证体系策略运营经验</div>
      <div class="m_des_item">
        互联网认证运营需要从用户帐号入驻、认证、使用多环节进行监督和管控；
      </div>
      <div class="m_des_item Mb24">
        而不同行业的经营准入和要求，国家有严格的要求。
      </div>
      <div class="masp_icon">
        <img src="@/assets/images/zizhi/tongdian3@2x.png" alt="" />
      </div>
      <div class="masp_title">高额运营成本</div>
      <div class="m_des_item">
        认证运营过程中的数据接口验证、平台搭建等服务均有准入门槛；
      </div>
      <div class="m_des_item">
        可能面临用户不规律增长带来的人员短缺和冗余，导致资源浪费；
      </div>
      <div class="m_des_item Mb24">
        密集型作业团队给管理也带来更多的风险和成本。
      </div>
    </div>
    <div class="m_panel" style="background: #f7f9fc">
      <div class="m_title">服务内容</div>
      <div class="masp_icon">
        <img src="@/assets/images/zizhi/service1@2x.png" alt="" />
      </div>
      <div class="masp_title">互联网社交平台认证</div>
      <div class="mass_des Mb24">
        为互联网社交平台提供认证体系搭建解决方案，帮助平台搭建个人认证体系、企业&机构认证体系。
      </div>
      <div class="masp_icon">
        <img src="@/assets/images/zizhi/service2@2x.png" alt="" />
      </div>
      <div class="masp_title">电商平台商户入驻和品牌认证</div>
      <div class="mass_des Mb24">
        为电商平台提供商户入驻、品牌验证体系解决方案，帮助平台验证商户资质、品牌授权等问题，为网民交易提供信任保障。
      </div>
    </div>
    <div class="m_panel">
      <div class="m_title">服务流程</div>
      <img
        src="@/assets/images/mobile/aptitude_safe/service_process@2x.png"
        alt=""
      />
    </div>
    <div class="m_panel" style="background: #f7f9fc">
      <div class="m_title Mb12">服务优势</div>
      <div class="masa_container">
        <div class="masa_item">
          <img src="@/assets/images/zizhi/youshi1@2x.png" alt="" />
          <div class="masa_title">1小时迅速响应</div>
          <div class="masa_des">1 小时内响应</div>
          <div class="masa_des">48 小时内通过</div>
        </div>
        <div class="masa_item">
          <img src="@/assets/images/zizhi/youshi2@2x.png" alt="" />
          <div class="masa_title">99.5%准确率交付</div>
          <div class="masa_des">准确率高于99.5%</div>
          <div class="masa_des">投诉率低于0.0005%</div>
        </div>
        <div class="masa_item">
          <img src="@/assets/images/zizhi/youshi3@2x.png" alt="" />
          <div class="masa_title">0信息安全事故</div>
          <div class="masa_des">数据加密传输</div>
          <div class="masa_des">作业现场网络隔离</div>
        </div>
        <div class="masa_item">
          <img src="@/assets/images/zizhi/youshi4@2x.png" alt="" />
          <div class="masa_title">人审规模600+</div>
          <div class="masa_des">团队规模超600人</div>
          <div class="masa_des">日审核企业超6W家</div>
        </div>
      </div>
    </div>
    <div class="m_panel">
      <div class="m_title Mb12">合作客户</div>
      <img src="@/assets/images/mobile/aptitude_safe/client@2x.png" alt="" />
      <div class="Tac Mt8">
        <a
          class="m_btn"
          href="https://www.yunaq.com/activity/activityform?name=业务安全"
        >
          立即咨询
        </a>
      </div>
    </div>
  </div>
</template>

<script>
import MobilePageBanner from '@/components/mobile/MobilePageBanner'

export default {
  name: 'MobileAptitudeSafe',
  components: {
    MobilePageBanner,
  },
}
</script>

<style lang="scss">
.m_aptitude_safe {
  text-align: start;
  .masp_icon {
    text-align: center;
    > img {
      width: 60px;
    }
  }
  .masp_title {
    margin: 12px 0;
    line-height: 24px;
    font-size: 14px;
    text-align: center;
  }
  .mass_des {
    padding: 0 16px;
    font-size: 12px;
    line-height: 16px;
    color: #686c78;
  }
  .masa_container {
    display: flex;
    width: calc(100% + 12px);
    flex-flow: wrap;
  }
  .masa_item {
    display: flex;
    flex-direction: column;
    box-sizing: border-box;
    min-height: 152px;
    width: calc(50% - 12px);
    margin-right: 12px;
    margin-top: 12px;
    align-items: center;
    justify-content: center;
    background: #fff;
    border: 1px solid #e6eaef;
    > img {
      width: 40px;
      height: 40px;
    }
    .masa_title {
      font-size: 12px;
      line-height: 24px;
      color: #1e1f23;
      margin-top: 8px;
      margin-bottom: 4px;
    }
    .masa_des {
      font-size: 12px;
      line-height: 20px;
      color: #686c78;
    }
  }
}
</style>
